import type { Workspace } from '@stratumn/studio-shared';
import { Trash } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DeleteWorkspaceDialog } from './DeleteWorkspaceDialog';

export type DangerZoneSectionProps = {
  workspace: Workspace | null;
  workflowNames?: Record<string, string>;
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  onConfirmDelete: () => Promise<void>;
};

export const DangerZoneSection = ({
  workspace,
  workflowNames,
  isOpen,
  onOpen,
  onClose,
  onConfirmDelete
}: DangerZoneSectionProps) => (
  <div className="rounded-xl bg-card p-6 shadow-verail">
    <h3 className="mb-1 font-medium text-lg">Danger Zone</h3>
    <p className="mb-4 text-muted-foreground text-sm">
      Permanently delete this workspace and all its data
    </p>
    <div className="flex items-center justify-between">
      <p className="text-sm">
        Once you delete a workspace, there is no going back.
      </p>
      <Button onClick={onOpen} size="sm" type="button" variant="destructive">
        <Trash />
        Delete this workspace
      </Button>
    </div>
    <DeleteWorkspaceDialog
      onClose={onClose}
      onConfirm={onConfirmDelete}
      workflowNames={workflowNames}
      workspace={isOpen ? workspace : null}
    />
  </div>
);
